<template>
  <div class="container legal-root">
    <header class="legal-head">
      <h1 class="title legal-title">{{ title }}</h1>
      <p class="legal-updated">Última actualización: {{ updatedAt }}</p>
      <p v-if="notice" class="legal-notice">{{ notice }}</p>
    </header>

    <div class="legal-layout">
      <!-- Índice lateral: los documentos legales se consultan por sección. -->
      <nav class="legal-index" aria-label="Índice del documento">
        <!-- Sin numeración propia: los títulos ya vienen numerados. -->
        <ul>
          <li v-for="section in sections" :key="section.id">
            <a :href="`#${section.id}`">{{ section.title }}</a>
          </li>
        </ul>
      </nav>

      <div class="legal-content">
        <section v-for="section in sections" :id="section.id" :key="section.id" class="legal-section">
          <h2 class="legal-section-title">{{ section.title }}</h2>
          <p v-for="(paragraph, index) in section.paragraphs" :key="index" class="legal-text">
            {{ paragraph }}
          </p>
          <ul v-if="section.items" class="legal-list">
            <li v-for="item in section.items" :key="item">{{ item }}</li>
          </ul>
        </section>

        <p class="legal-contact">
          Para cualquier solicitud relacionada con este documento escríbenos a
          <strong>{{ contactEmail }}</strong>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, computed, ref } from 'vue';

export default {
  name: 'LegalPage',
  props: {
    title: { type: String, required: true },
    updatedAt: { type: String, required: true },
    notice: { type: String, default: '' },
    sections: { type: Array, required: true },
  },
  setup() {
    const company = inject('company', ref(null));
    const contactEmail = computed(() => company.value?.email || 'contacto@selk.com.co');
    return { contactEmail };
  },
};
</script>

<style scoped>
.legal-root {
  padding-bottom: var(--space-xl);
}

.legal-head {
  margin-bottom: var(--space-lg);
}

.legal-title {
  margin: var(--space-md) 0 var(--space-xs) 0;
}

.legal-updated {
  font-family: var(--font-body);
  font-size: 16px;
  color: var(--color-text);
  margin: 0;
}

.legal-notice {
  font-family: var(--font-body);
  font-size: 16px;
  color: #854D0E;
  background: rgba(234, 179, 8, 0.12);
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  margin: var(--space-sm) 0 0 0;
}

.legal-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: var(--space-xl);
  align-items: start;
}

.legal-index {
  position: sticky;
  top: calc(var(--header-offset) + var(--space-sm));
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: var(--space-md);
}

.legal-index ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.legal-index li {
  margin-bottom: var(--space-xs);
}

.legal-index a {
  font-family: var(--font-body);
  font-size: 16px;
  color: var(--color-action);
  text-decoration: none;
}

.legal-index a:hover {
  color: var(--color-brand);
  text-decoration: underline;
}

.legal-section {
  margin-bottom: var(--space-lg);
  scroll-margin-top: calc(var(--header-offset) + var(--space-sm));
}

.legal-section-title {
  font-family: var(--font-subtitle);
  font-weight: 700;
  font-size: 26px;
  line-height: 1.2;
  color: var(--color-title);
  margin: 0 0 var(--space-sm) 0;
}

.legal-text {
  font-family: var(--font-body);
  font-size: 18px;
  line-height: 1.6;
  color: var(--color-text);
  margin: 0 0 var(--space-sm) 0;
}

.legal-list {
  margin: 0 0 var(--space-sm) 0;
  padding-left: 1.2rem;
}

.legal-list li {
  font-family: var(--font-body);
  font-size: 18px;
  line-height: 1.6;
  color: var(--color-text);
  margin-bottom: 0.3rem;
}

.legal-contact {
  font-family: var(--font-body);
  font-size: 18px;
  line-height: 1.6;
  color: var(--color-text);
  border-top: 1px solid var(--color-border);
  padding-top: var(--space-md);
}

@media (max-width: 1024px) {
  .legal-layout {
    grid-template-columns: 1fr;
    gap: var(--space-md);
  }
  .legal-index {
    position: static;
  }
}

@media (max-width: 800px) {
  .legal-title {
    font-size: 2rem;
    line-height: 1.2;
    letter-spacing: 0;
  }
}
</style>
